import React from "react";
import { Banner } from "./Banner";
import i18n from "src/locales";

function AffiliateTrialModalContent() {
  return (
    <>
      <strong>{i18n.t("affiliateTrialBanner:offerTerms:title")}</strong>
      <ul>
        <li>{i18n.t("affiliateTrialBanner:offerTerms:text1")}</li>
        <li>{i18n.t("affiliateTrialBanner:offerTerms:text2")}</li>
        <li>{i18n.t("affiliateTrialBanner:offerTerms:text3")}</li>
      </ul>
    </>
  );
}

export function AffiliateTrialBanner() {
  return (
    <Banner
      fullWidth={false}
      headline="affiliateTrialBanner:headline"
      modalContent={<AffiliateTrialModalContent />}
    />
  );
}
